import { render, staticRenderFns } from "./relatorio-pets-unidade.vue?vue&type=template&id=5dec8926&"
import script from "./relatorio-pets-unidade.vue?vue&type=script&lang=js&"
export * from "./relatorio-pets-unidade.vue?vue&type=script&lang=js&"
import style0 from "./relatorio-pets-unidade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect,VSpeedDial})
